// extracted by mini-css-extract-plugin
export default {"external":"styles_external__W4xFd"};